<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Create CCIC Application</md-dialog-title>

      <md-dialog-content>
        <form novalidate @submit.prevent="doSave">

          <md-field>
            <label>CCIC Application No</label>
            <md-input v-model="dataForm.applicationNo"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.bookingNo')">
            <label>Booking No</label>
            <md-input v-model="dataForm.bookingNo"/>
            <span class="md-error" v-if="!$v.dataForm.bookingNo.required">Booking No is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.poNo')">
            <label>Po No</label>
            <md-input v-model="dataForm.poNo"/>
            <span class="md-error" v-if="!$v.dataForm.poNo.required">PO No is required</span>
          </md-field>

          <master-data-select label="Pickup Location Group"
                              v-model="dataForm.pickUpLocationGroup"
                              group="CCIC_SUPPLIER_GROUPS"
          />

          <div :class="getValidationClass('dataForm.pickUpLocationId')">
            <autocomplete-ccic-location-select
                v-if="dataForm.pickUpLocationGroup"
                label="Pickup Location"
                :group="dataForm.pickUpLocationGroup"
                v-model="dataForm.pickUpLocationId"
                :on-item-selected="handlePickLocationChanged"
            />
            <md-content v-else class="md-accent">
              User does not have 'CCIC Group', please set it before creating application.
            </md-content>
            <span class="md-error" v-if="!$v.dataForm.pickUpLocationId.required">Pickup Location is required</span>
          </div>

          <div v-if="dataForm.pickUpLocation">
            <div>{{dataForm.pickUpLocation.tagName}}</div>
            <div>
              {{dataForm.pickUpLocation.yardPostalCode}} {{dataForm.pickUpLocation.yardRegion}} {{dataForm.pickUpLocation.yardCity}}
              {{dataForm.pickUpLocation.yardStreet}}
            </div>
          </div>

          <calling-api type="bar" path="/api/w/ccic/application/create">

            <md-dialog-actions>
              <md-button class="md-primary" @click="showDialog = false">Close</md-button>
              <md-button type="submit" class="md-primary">Save</md-button>
            </md-dialog-actions>

          </calling-api>


        </form>

      </md-dialog-content>
    </md-dialog>
  </div>

</template>
<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
  }
</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { required } from 'vuelidate/lib/validators';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";

  const getInitialDataForm = () => ({
    user: null,
    applicationNo: null,
    poNo: null,
    bookingNo: null,
    pickUpLocation: null,
    pickUpLocationGroup: null,
    pickUpLocationId: null,
    pickUpLocationName: null,
    pickUpLatitude: null,
    pickUpLongitude: null,
  });


  export default {
    components: { AutocompleteCcicLocationSelect },
    mixins: [validationMixin],
    data: () => ({
      showDialog: false,
      dataForm: getInitialDataForm(),
    }),
    computed: {
      ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getUserProfile',
      ]),
      getPickupLocationOptions() {
        const { ccicSupplierGroup } = this.getUserProfile;
        if (ccicSupplierGroup) {
          return this.getMasterDataAsSelectOptionByGroup(ccicSupplierGroup);
        }
        return [];
      },
    },
    watch: {
      showDialog(val) {
        if (val === false) {
          this.$store.commit('clearApiError');
        }
      },
    },
    validations: {
      dataForm: {
        bookingNo: {
          required,
        },
        poNo: {
          required,
        },
        pickUpLocationId: {
          required,
        },
      },
    },
    methods: {
      handlePickLocationChanged(item) {
        if (item) {
          this.dataForm.pickUpLocation = item;
          this.dataForm.pickUpLocationName = item.tagName;
        } else {
          this.dataForm.pickUpLocation = null;
          this.dataForm.pickUpLocationId = null;
        }
      },
      openDialog() {
        this.dataForm = getInitialDataForm();
        this.$v.dataForm.$reset();
        this.showDialog = true;
        this.dataForm.pickUpLocationGroup = this.getUserProfile.ccicSupplierGroup;
        this.$store.dispatch('refreshUserProfile');
      },
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      doSave() {
        this.$v.dataForm.$touch();
        console.log(this.$v.dataForm.$invalid);
        if (this.$v.dataForm.$invalid) {
          return;
        }

        this.dataForm.user = this.getUserProfile.username;

        console.log(JSON.stringify(this.dataForm));

        //api.post("/api/w/ccic/application/create", this.dataForm)
        newAPIPost("/api/w/ccic/application/create", this.dataForm)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            $('.btn-search-ccic-application')
              .click();
          });
      },
    },
  };


</script>
